import React from 'react';
import APIService from '../../Service/APIService';
import GenericDashboard from '../GenericDashboard/GenericDashboard';
import CustomHeader from '../CustomHeader/CustomHeader';
import moment from 'moment';
import { Badge, Flex, Spin, Tooltip, Button } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import useDateFilteredData from './CustomDateHook';
import DateRangeFilter from './DateRangeFilter';
import { ClockCircleFilled } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthProvider.js';
const IVRSubmissions = (props) => {
  const { user } = useAuth();
  const userData = user;
  const navigate = useNavigate();
  const [ivrs, setIvrs] = React.useState([]);
  const [allIvrs, setAllIvrs] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [show, setShow] = React.useState(false);
  const [isFilter, setIsFilter] = React.useState(false);
  const [selectedFilter, setSelectedFilter] = React.useState('');
  const [allInvoices, setAllInvoices] = React.useState([]);
  const getIvrSubmisions = async () => {
    const apiService = new APIService();
    const response = await apiService.getDataFromBackend("ivrsubmissions");
    console.log("IVR Submissions Response:", response?.data?.data);
    return response?.data?.data;
  }
  React.useEffect(() => {
    if (userData?.Type === "Account" && !userData?.EnableIVR) {
      navigate('/');
    }
    // if(userData?.Type === "Manufacturer") {
    //   navigate('/');
    // }
    getIvrSubmisions().then(async (data) => {
      // console.log("IVR Submissions: ", data);
      let tempData = data;
      // get IVR Manufacturers for this IVR ID
      let ivrArr = [];

      for (let i = 0; i < tempData?.length; i++) {
        const item = tempData[i];
        const manufactInitials = item.InsuranceStatus;
        let caseIDs = [];
        if (manufactInitials) {
          const initialsArr = JSON.parse(manufactInitials);
          caseIDs = initialsArr.map((item) => {
            let nameStr = item.ManufacturerInitials;
            let badgeStyle = {};
            switch (item.InsuranceStatus) {
              case "Covered":
                badgeStyle = { marginRight: '8px', backgroundColor: 'green', outlineStyle: 'solid', outlineColor: 'green' };
                break;
              case "Not Covered":
                badgeStyle = { marginRight: '8px', backgroundColor: 'red', outlineStyle: 'solid', outlineColor: 'red' };
                break;
              case "Info Required":
                badgeStyle = { marginRight: '8px', outlineStyle: 'solid', outlineColor: 'red', color: 'black', backgroundColor: 'white' };
                break;
              case "Submitted":
                badgeStyle = { marginRight: '8px', outlineStyle: 'solid', outlineColor: 'blue', backgroundColor: 'white', color: 'black' };
                break;
              default:
                break;
            }
            return (
              <Tooltip placement="top" title={`${item.ManufacturerName} - ${item.InsuranceStatus}`}>
                <Badge count={nameStr} style={badgeStyle} />
              </Tooltip>
            );
          });
        }
        let tempObj = { ...item };
        tempObj.SubmissionDate = moment(item.SubmissionDate).format("MM-DD-YYYY");
        tempObj.CaseIDStatus = <span style={{ float: 'right' }}>{caseIDs}</span>;
        ivrArr.push(tempObj);
      }
      console.log("IVR Submissions: ", ivrArr);
      setIvrs(ivrArr);
      setAllIvrs(ivrArr);
    }).then(() => {
      setLoading(false);
    });
  }, []);

  const {
    data,
    loader,
    error,
    fetchData,
    currentFilters,
    tCount,
    tPages
  } = useDateFilteredData("ivrsubmissions", 0, 10, null, {
    fetchOnMount: false,
    transformResponse: (data) => {
      let tempData = data;
      // get IVR Manufacturers for this IVR ID
      let ivrArr = [];

      for (let i = 0; i < tempData?.length; i++) {
        const item = tempData[i];
        const manufactInitials = item.InsuranceStatus;
        let caseIDs = [];
        if (manufactInitials) {
          const initialsArr = JSON.parse(manufactInitials);
          caseIDs = initialsArr.map((item) => {
            let nameStr = item.ManufacturerInitials;
            let badgeStyle = {};
            switch (item.InsuranceStatus) {
              case "Covered":
                badgeStyle = { marginRight: '8px', backgroundColor: 'green', outlineStyle: 'solid', outlineColor: 'green' };
                break;
              case "Not Covered":
                badgeStyle = { marginRight: '8px', backgroundColor: 'red', outlineStyle: 'solid', outlineColor: 'red' };
                break;
              case "Info Required":
                badgeStyle = { marginRight: '8px', outlineStyle: 'solid', outlineColor: 'red', color: 'black', backgroundColor: 'white' };
                break;
              case "Submitted":
                badgeStyle = { marginRight: '8px', outlineStyle: 'solid', outlineColor: 'blue', backgroundColor: 'white', color: 'black' };
                break;
              default:
                break;
            }
            return (
              <Tooltip placement="top" title={`${item.ManufacturerName} - ${item.InsuranceStatus}`}>
                <Badge count={nameStr} style={badgeStyle} />
              </Tooltip>
            );
          });
        }
        let tempObj = { ...item };
        tempObj.SubmissionDate = moment(item.SubmissionDate).format("MM-DD-YYYY");
        tempObj.CaseIDStatus = <span style={{ float: 'right' }}>{caseIDs}</span>;
        ivrArr.push(tempObj);
      }
      setIvrs(ivrArr);
      setAllIvrs(ivrArr);
    },
  });

  const handleDateFilterChange = async (dateRange) => {
    await fetchData(dateRange);
  };

  const handleFilter = (filter) => {
    console.log('Filter:', filter);
    const jsDate = new Date();
    // const currentDate = dayjs(jsDate.toDateString()).format("MM-DD-YYYY");
    const currentDate = dayjs(jsDate.toDateString());
    // const currentDate = moment(jsDate.toDateString(), "MM-DD-YYYY");
    if (filter === 'Submitted') {
      let tempData = [];

      // filter all ivrs where InsuranceStatus columns has Submitted
      for (let i = 0; i < allIvrs.length; i++) {
        let tempObj = allIvrs[i];
        let manStatus = JSON.parse(tempObj.InsuranceStatus);
        if (manStatus) {
          // check if insuranceStatus in manStatus includes Submitted
          let isSubmitted = manStatus.some((item) => item.InsuranceStatus === "Submitted");
          if (isSubmitted) {
            tempData.push(tempObj);
          }
        }
      }

      setIsFilter(true);
      setSelectedFilter('Submitted');
      setIvrs(tempData);
    }
    else if (filter === 'Covered') {
      let tempData = [];

      // filter all ivrs where InsuranceStatus columns has Submitted
      for (let i = 0; i < allIvrs.length; i++) {
        let tempObj = allIvrs[i];
        let manStatus = JSON.parse(tempObj.InsuranceStatus);
        if (manStatus) {
          // check if insuranceStatus in manStatus includes Submitted
          let isCovered = manStatus.some((item) => item.InsuranceStatus === "Covered");
          if (isCovered) {
            tempData.push(tempObj);
          }
        }
      }
      setIsFilter(true);
      setSelectedFilter('Covered');
      setIvrs(tempData);
    }
    else if (filter === 'Not Covered') {
      let tempData = [];

      // filter all ivrs where InsuranceStatus columns has Submitted
      for (let i = 0; i < allIvrs.length; i++) {
        let tempObj = allIvrs[i];
        let manStatus = JSON.parse(tempObj.InsuranceStatus);

        if (manStatus) {
          // check if insuranceStatus in manStatus includes Submitted
          let isNotCovered = manStatus.some((item) => item.InsuranceStatus === "Not Covered");
          if (isNotCovered) {
            tempData.push(tempObj);
          }
        }
      }
      setIsFilter(true);
      setSelectedFilter('Not Covered');
      setIvrs(tempData);
    }
    else if (filter === 'Info Required') {
      let tempData = [];

      // filter all ivrs where InsuranceStatus columns has Submitted
      for (let i = 0; i < allIvrs.length; i++) {
        let tempObj = allIvrs[i];
        let manStatus = JSON.parse(tempObj.InsuranceStatus);
        if (manStatus) {
          // check if insuranceStatus in manStatus includes Submitted
          let isInfoRequired = manStatus.some((item) => item.InsuranceStatus === "Info Required");
          if (isInfoRequired) {
            tempData.push(tempObj);
          }
        }
      }
      setIsFilter(true);
      setSelectedFilter('Info Required');
      setIvrs(tempData);
    }
    else if (filter === 'Clear') {
      setIsFilter(false);
      setSelectedFilter('');
      setIvrs(allIvrs);
    }
  }

  return (
    <div>
      <CustomHeader leftTopText="Welcome back!" leftBottomText="IVR Submissions" leftBottomExtraText={`${ivrs.length}`}
        rightTopText="Logged in as Admin" rightBottomText="User" />
      {loading &&
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      }
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
        <DateRangeFilter
          onFilterChange={handleDateFilterChange}
          labelText="Filter by date"
        />
        <>
          <span style={{ float: "right" }}>
            <span style={{ marginRight: '8px' }}>Filters: </span>
            <Badge count={"Submitted"} style={{ cursor: 'pointer', marginRight: '8px', outlineStyle: 'solid', outlineColor: 'blue', backgroundColor: 'white', color: 'black', }} onClick={() => handleFilter("Submitted")} />
            <Badge count={"Covered"} style={{ cursor: 'pointer', marginRight: '8px', backgroundColor: 'green', outlineStyle: 'solid', outlineColor: 'green' }} onClick={() => handleFilter("Covered")} />
            <Badge count={"Not Covered"} style={{ cursor: 'pointer', marginRight: '8px', backgroundColor: 'red', outlineStyle: 'solid', outlineColor: 'red' }} onClick={() => handleFilter("Not Covered")} />
            <Badge count={"Info Required"} style={{ cursor: 'pointer', marginRight: '8px', outlineStyle: 'solid', outlineColor: 'red', color: 'black', backgroundColor: 'white' }} onClick={() => handleFilter("Info Required")} />
            {isFilter &&
              <Badge count={"Clear"} style={{ cursor: 'pointer', marginRight: '8px', outlineStyle: 'solid', outlineColor: 'white', color: 'black', backgroundColor: 'white' }} onClick={() => handleFilter("Clear")} />
            }
          </span>
        </>
      </div>
      {
        !loading &&
        <GenericDashboard data={ivrs} screen="IVRSubmissions" />
      }
    </div>
  )
}

export default IVRSubmissions;